<template>
    <div>
      <b-row>
        <b-colxx lg="4" sm="4" md="4" xs="12">
          <piaf-breadcrumb/>          
        </b-colxx>
          <b-colxx lg="3" sm="3" md="3" xs="12">
            <div class="form-group has-float-label" style="margin-top: 5px;">
                <v-select size="xs" v-model="select_store" :options="storeList" style="height: 1px;" @change="selectStore()" />
                <span>Store</span>
          </div>          
          </b-colxx>
          <b-colxx lg="3" sm="12" md="6" xs="12" style="margin-top: 3px;">
            <button v-if="is_locked == 'false'" class="btn btn-info btn-sm" v-bind:disabled="!select_store.value || is_empty == true || statusRight.isenabled == 0" @click="onUpdateByStore()">Update Status</button>
            <button class="btn btn-warning btn-sm" @click="onloadData()"><i class="simple-icon-refresh" style="font-size:16px;"></i> Refresh</button>
            <button class="btn btn-success btn-sm" @click="exportCheckInData()">Export to Report</button>            
          </b-colxx>
          <!-- <b-colxx lg="1" sm="1" md="1" xs="6" style="margin-top: 3px;">
            <button class="btn btn-warning btn-sm" @click="onloadData()"><i class="simple-icon-refresh" style="font-size:16px;"></i> Refresh</button>
          </b-colxx>
          <b-colxx lg="1" sm="1" md="1" xs="6" style="margin-top: 3px;">
            <button class="btn btn-success btn-sm" @click="exportCheckInData()">Export to Report</button>
          </b-colxx> -->
        <b-colxx lg="2" sm="2" md="2" xs="12">          
          <span style="float: right; font-size:20px; margin-top:10px;">{{ emp.dc_fullname }}</span>
        </b-colxx>        
      </b-row>
      <b-row>
        <b-colxx lg="12" sm="12" md="12" xs="12">
          <div class="separator mb-2"></div>
        </b-colxx>
      </b-row>
    <br>
      <b-row>
        <b-colxx xxs="12">
            <b-card class="mb-1" :style="'min-height:'+(height-290)+'px;'">
              <div class="loading" v-if="loading"></div>
              <b-row>
                <b-colxx  v-for="(v,i) in dataList" :key="i" lg="2" sm="3" md="3" xs="12">
                     <b-card class="mb-4" no-body>
                      <div class="position-relative">
                            <img :src="getimg(v.img_check)" class="card-img-top"/>
                            <b-badge variant="primary" pill class="position-absolute badge-top-right">{{ DateCh(v.detecheck)}}</b-badge>
                            <b-badge variant="primary" pill class="position-absolute badge-top-left">{{ v.type }}</b-badge>
                            <b-badge variant="success" pill class="position-absolute badge-top-left-2">{{ v.time ||"00:00" }}</b-badge>
                            <b-badge variant="success" pill class="position-absolute badge-top-right-2" v-if="v.status == '1'">{{ v.status }}</b-badge>
                            <b-badge variant="danger" pill class="position-absolute badge-top-right-2" v-if="v.status == 'X'">{{ '1' }}</b-badge>
                            <b-badge variant="danger" pill class="position-absolute badge-top-right-2" v-if="v.status == 'S' || v.status == 'X1'">{{ v.status }}</b-badge>
                            <b-badge variant="danger" pill class="position-absolute badge-top-right-2" v-if="v.status == 'NC'">{{ 'SH' }}</b-badge>
                        </div>
                        <b-card-body>
                            <p class="mb-1 text-muted  w-sm-100"><span class="texth">Project</span> : {{ v.pre_des }} </p>
                            <p class="mb-1 text-muted  w-sm-100" v-if="v.img_type == 'CK'"><span class="texth">Ref. Code</span> :  {{	v.refcode }}</p>
                            <p class="mb-1 text-muted  w-sm-100"><span class="texth">Store</span> :  {{ v.store_name }}</p>
                            <p class="mb-1 text-muted  w-sm-100"><span class="texth">Account</span> :  {{ v.account_name }}</p>                            
                            <p class="mb-1 text-muted  w-sm-100" v-if="v.img_type == 'CC'"><span class="texth">Brand</span> :  {{ v.brand_name }}</p>
                            <p class="mb-1 text-muted  w-sm-100" v-if="v.img_type == 'CC'"><span class="texth">Quotation</span> : {{ v.quo_no }}</p>
                            <p class="mb-1 text-muted  w-sm-100"><span class="texth">Province</span> : {{ v.province_name }}</p>
                            <p class="mb-1 text-muted  w-sm-100" v-if="v.img_type == 'CK'"><span class="texth">Remark</span> :  {{ v.remark	 }}</p>
                            <b-form-group class="pull-right">
                              <b-form-checkbox v-model="v.recheck" unchecked-value="false" >Check</b-form-checkbox>
                            </b-form-group>
                        </b-card-body>
                    </b-card>
                  </b-colxx>
                </b-row>
            </b-card>
        </b-colxx>
      </b-row>
      <br><br>
       <div class="chat-input-container">
        <div>
          <b-row v-if="lastPage>1">
            <b-colxx xxs="12">
              <b-pagination-nav
                v-model="page"
                @input="linkGen()"
                :number-of-pages="perPage"
                base-url="#"
                class="mt-2"
                align="center"
              >
                <template v-slot:next-text>
                  <i class="simple-icon-arrow-right"/>
                </template>
                <template v-slot:prev-text>
                  <i class="simple-icon-arrow-left"/>
                </template>
                <template v-slot:first-text>
                  <i class="simple-icon-control-start"/>
                </template>
                <template v-slot:last-text>
                  <i class="simple-icon-control-end"/>
                </template>
              </b-pagination-nav>
            </b-colxx>
          </b-row>
        </div>
      </div>

      <!-- Modal : Update Status -->
    <div>
      <b-modal v-model="updateByStore"
               centered
               hide-footer
               :no-close-on-backdrop="true"
               size="lg"
               :no-close-on-esc="true">
        <template slot="modal-title">
          <b-row>
            <b-colxx xxs="12" sm="2" md="12" lg="12">
              Update Status
            </b-colxx>
          </b-row> 
        </template>
        <b-row class="icon-cards-row mb-3">
          <b-colxx xxs="3" sm="2" md="2" lg="1.5">
            <b-card class="mb-1 classStatusActive text-center classHover"
                    v-bind:class="{ 'disabled-menu': statusRight.isenabled == 0 }"
                    @click="onSetStatus('1')">
              <h1 class="topClass">
                1 <i class="simple-icon-lock" style="font-size: 20px"></i>
                <br />
                <span class="textClass">Visit ที่ทำงาน</span>
              </h1>
            </b-card>
          </b-colxx>
          <b-colxx xxs="3" sm="2" md="2" lg="1.5">
            <b-card class="mb-1 classStatusRed text-center classHover"
                    v-bind:class="{ 'disabled-menu': statusRight.isenabled == 0 }"
                    @click="onSetStatus('S')">
              <h1 class="topClass">
                S <i></i><br />
                <span class="textClass">ภายใน</span>
              </h1>
            </b-card>
          </b-colxx>
          <b-colxx xxs="3" sm="2" md="2" lg="1.5">
            <b-card class="mb-1 classStatusRed text-center classHover"
                    v-bind:class="{ 'disabled-menu': statusRight.isenabled == 0 }"
                    @click="onSetStatus('X1')">
              <h1 class="topClass">
                X1 <i></i><br />
                <span class="textClass">ไม่คิดเงิน</span>
              </h1>
            </b-card>
          </b-colxx>
          <b-colxx xxs="3" sm="2" md="2" lg="1.5">
            <b-card class="mb-1 classStatusRed text-center classHover"
                    v-bind:class="{ 'disabled-menu': statusRight.isenabled == 0 }"
                    @click="onSetStatus('NC')">
              <h1 class="topClass">
                SH <i></i><br />
                <span class="textClass">No Check In</span>
              </h1>
            </b-card>
          </b-colxx>          
        </b-row>

        <b-button size="sm"
                  variant="primary"
                  style="float: right; margin-right: 5px"
                  @click="confirmByStore()">แก้ไขสถานะ</b-button>

        <span class="statusText" style="float: right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        
        <span class="statusText"
              style="float: right; margin-top: 5px"
              v-if="status_plan == 'S'">
          สถานะที่เลือก : [S] ภายใน
        </span>
        <span class="statusText"
              style="float: right; margin-top: 5px"
              v-if="status_plan == '1'">
          สถานะที่เลือก : [1] วันทำงาน(คิดเต็มวัน)
        </span>
        <span class="statusText"
              style="float: right; margin-top: 5px"
              v-if="status_plan == 'X1'">
          สถานะที่เลือก : [X1] ไม่คิดเงิน
        </span>
        <span class="statusText"
              style="float: right; margin-top: 5px"
              v-if="status_plan == 'NC'">
          สถานะที่เลือก : [SH] Not Check In
        </span>
      </b-modal>
    </div>

       <b-modal  v-model="modalShowing" centered title="Image" size="lg" :hide-footer="true" style="width:80%;">
              <div>
                   <img :src="createFilePath(imgShow)"  height="100%"/>
              </div>
            </b-modal>
          <loadingbox :active="loadingx" spinner="spinner" color="dimgray" :text="export_progress" is-full-screen />
      </div>
      
    </template>
    <script>
    import { apiUrl, xtools } from '@/constants/config'
    import vSelect from 'vue-select'
    import moment from 'moment'
    import linq from 'js-linq'
    import { all } from 'q'
    import loadingbox from 'vue-element-loading'
    var tabCostheight = window.innerHeight
    const $linq = function (arr) {
      return linq.from(arr)
    }
    
    export default {
      components: { vSelect,loadingbox },
      data () {
        return {
          imgShow:"",
          modalShowing:false,
          docno:"",
          datechk:"",
          empcode:"",
          select_store: {},
          storeList: [],
          checkin_detail: [],
          callcard_detail: [],
          loadingx: false,
          activeTabs1: true,
          activeTabs2: false,
          updateByStore: false,
          is_empty: false,
          status_plan: '',
          export_progress:'',
          skip: 0,
          error_mgs: '',
          height: tabCostheight,
          loading: false,
          is_locked: false,
          page: 1,
          perPage: 4,
          search: '',
          from: 0,
          to: 0,
          total: 0,
          lastPage: 15,
          limitPage: 30,
          search: '',
          modalShow: false,
          fromWh: { value: 'holiday_name', label: 'holiday Name' },
          emp:{},
          dataList: [],
          dataH: {},
          auth: window.auth,
          menuRight: window.menuRight,
          subRight: window.subMenuRight,
          statusRight: { isenabled: 0 },
          fromList: [
            { value: 'holiday_code', label: 'Holiday Code' },
            { value: 'holiday_name', label: 'Holiday Name' }
          ]
        }
      },
      methods: {
        getimg(img){
          if(img){
            return apiUrl + "api/file/download/?download=false&id="+img;
          }
        },
        onshowimg(img){
          this.modalShowing = true;
          this.imgShow = img;
        },
        createFilePath(img) {
          return (img!=null)?apiUrl + 'api/file/download/?download=false&id=' + img:"../../../assets/img2/picture.svg";
        },
        linkGen () {
          this.onloadData()
        },
        async exportCheckInData(){
          this.$set(this, 'export_progress', 'กำลัง Export กรุณารอจนกว่ากระบวนการเสร็จสิ้น');
          this.$set(this, 'loadingx', true);
          let url = `AccountingforLabor/Transaction/ExportCheckinROData?docno=${this.docno}&datechk=${this.datechk}&empcode=${this.empcode}`;
          let result = await xtools.getServer(url);
          this.$set(this, 'loadingx', false);
          window.open(apiUrl + `API/File/DownLoad?download=true&id=${result.data.token_hex}`);
        },
        DateCh: function (date) {
          return date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : ''
        },

        async onLoadStore() {

        let working_date = moment(this.datechk, 'DD/MM/YYYY').format("YYYY-MM-DD")
        let data = await xtools.getServer(
              "AccountingforLabor/Transaction/labourShareService_ReadSubdetailByDocno?dc_docno=" + this.docno + "&dc_team_id=" + this.empcode + "&working_date=" + working_date
        );

        let storeList = []
        data.data.ls_store_ck.forEach((v, i) => {
              v.store_name = v.store_code_sh + " : " + v.store_name;
              storeList.push({ value: v.store_code_sh, label: v.store_name })
        })

        this.$set(this, 'storeList', $linq(storeList).orderBy(y => y.label).toArray());
        },

        async onloadData () { // โหลด store
          this.dataList = []
          this.select_store = {}
          
          this.$set(
            this,
            "export_progress",
            "กำลังโหลดข้อมูล กรุณารอสักครู่"
          );
          this.$set(this, "loadingx", true);

          this.skip = ((this.limitPage * this.page) - this.limitPage) || 0
          var form = new FormData()
          form.append('docno', this.docno)
          form.append('datechk', this.datechk)
          form.append('empcode', this.empcode)
          form.append('from', this.fromWh.value)
          form.append('search', this.search)
          form.append('skip', (this.limitPage * this.page) - this.limitPage)
          form.append('take', 9999)
          let data = await xtools.postServerForm('AccountingforLabor/Transaction/loadRO_Checkin_ImgByEmp', form)          

          this.$set(this, 'checkin_detail', data.data.ck_detail);
          this.$set(this, 'callcard_detail', data.data.cc_detail);
    
          data.data.ck_detail.forEach((x, i) => {
            let all_visit = $linq(data.data.cc_detail).where(w => w.time_checkin == x.time_checkin).toArray()
            let is_allgreen = $linq(data.data.cc_detail).where(w => w.time_checkin == x.time_checkin && w.visit_status == '1').toArray()
            console.log(all_visit.length, 'all')
            console.log(is_allgreen.length, 'green')            
            if(all_visit.length > 0) {
              if(all_visit.length == is_allgreen.length){
                x.recheck = 'Y'
              }
            }

            x.recheck = x.recheck == 'N' ? false : x.recheck == 'Y' ? true : x.recheck
            var v_in = {
                pre_des: x.pre_des,                
                store_name: x.store_name,
                account_name: x.account_name,
                province_name: x.province_name,
                dc_fullname: x.dc_fullname,
                refcode: x.refcode,
                time: x.time_checkin,
                img_check: x.img_checkin,
                remark: x.remark_ckeckin,
                detecheck: x.detecheck,
                recheck: x.recheck,
                type: "Check In",
                img_type: "CK"
              }
            this.dataList.push(v_in);

            data.data.cc_detail.forEach((v, i) => {
              if(v.visit_status == '1'){
              v.recheck = 'Y'
              }
              v.recheck = v.recheck == 'N' ? false : v.recheck == 'Y' ? true : v.recheck
              if(x.time_checkin == v.time_checkin){
                v.callcard.forEach((v2, i2) => {
                  var dt = {                
                      pre_des:v.pre_des,
                      store_name:v.store_name,                
                      account_name:v.account_name,
                      province_name: v.province_name,
                      brand_name:v.brand_name,
                      dc_fullname: v.dc_fullname,
                      status: v.visit_status,
                      time: v.callcard_time[i2],
                      img_check: v.callcard[i2].callcard_img,
                      detecheck: v.working_date,
                      recheck: v.recheck,
                      quo_no: v.quo_no,
                      type: "Callcard",
                      img_type: "CC",
                      subitemno: v.subitemno
                  }
                  this.dataList.push(dt);

                })
              }
            })

            var v_out = {
                pre_des: x.pre_des,                
                store_name: x.store_name,
                account_name: x.account_name,
                province_name: x.province_name,
                dc_fullname: x.dc_fullname,
                refcode: x.refcode,
                detecheck: x.detecheck,
                time: x.time_checkout,
                img_check: x.img_checkout,
                remark: x.remark_checkout,
                detecheck: x.detecheck,
                recheck: x.recheck,
                type: "Check Out",
                img_type: "CK"
              }
            this.dataList.push(v_out);
          })
    
          this.emp = data.data.emp || {};
          //this.perPage = ((data.data.total / this.limitPage) < 0) ? 1 : (data.data.total / this.limitPage) + 1
          this.$set(this, "loadingx", false);
        },

        async selectStore() {
          this.$set(
            this,
            "export_progress",
            "กำลังโหลดข้อมูล กรุณารอสักครู่"
          );
          this.$set(this, "loadingx", true);

          this.dataList = []          
          let ck_by_store = $linq(this.checkin_detail).where(w => w.store_code_sh == this.select_store.value).toArray()
          let cc_by_store = $linq(this.callcard_detail).where(w => w.store_code_sh == this.select_store.value).toArray()

          if(ck_by_store.length == 0){
            this.is_empty = true
          } else {
            this.is_empty = false
          }
    
          ck_by_store.forEach((x, i) => {
            var v_in = {
                pre_des: x.pre_des,                
                store_name: x.store_name,
                account_name: x.account_name,
                province_name: x.province_name,
                dc_empcode: x.dc_empcode,
                dc_docno: x.dc_docno,
                dc_fullname: x.dc_fullname,
                refcode: x.refcode,
                time: x.time_checkin,
                time_checkin: x.time_checkin,
                img_check: x.img_checkin,
                remark: x.remark_ckeckin,
                detecheck: x.detecheck,
                recheck: x.recheck,
                type: "Check In",
                img_type: "CK"
              }
            this.dataList.push(v_in);

            cc_by_store.forEach((v, i) => {
              if(x.time_checkin == v.time_checkin){
                v.callcard.forEach((v2, i2) => {
                  var dt = {                
                      pre_des:v.pre_des,
                      store_name:v.store_name,                
                      account_name:v.account_name,
                      province_name: v.province_name,
                      brand_name:v.brand_name,
                      dc_fullname: v.dc_fullname,
                      dc_docno: v.dc_docno,
                      dc_team_id: v.dc_team_id,
                      store_code_sh: this.select_store.value,
                      status: v.visit_status,
                      time: v.callcard_time[i2],
                      img_check: v.callcard[i2].callcard_img,
                      detecheck: v.working_date,
                      working_date: v.working_date,
                      recheck: v.recheck,
                      quo_no: v.quo_no,
                      type: "Callcard",
                      img_type: "CC",
                      subitemno: v.subitemno
                  }
                  this.dataList.push(dt);

                })
              }
            })

            var v_out = {
              pre_des: x.pre_des,                
                store_name: x.store_name,
                account_name: x.account_name,
                province_name: x.province_name,
                dc_fullname: x.dc_fullname,
                refcode: x.refcode,
                detecheck: x.detecheck,
                time: x.time_checkout,
                img_check: x.img_checkout,
                remark: x.remark_checkout,
                detecheck: x.detecheck,
                recheck: x.recheck,
                type: "Check Out",
                img_type: "CK"
              }
            this.dataList.push(v_out);
          })

          this.$set(this, "loadingx", false);
        },

        onUpdateByStore() {
          console.log(this.dataList, 'data')
          let checked_all = $linq(this.dataList).where(w => w.recheck != true).toArray()
          if(checked_all.length > 0) {
            alert(
              "กรุณากด Check รูปภาพให้ครบก่อนทำการ Update Status"
            );
            return false;
          }

          let check_out = $linq(this.dataList).where(w => w.type == 'Check Out').firstOrDefault()
          console.log(check_out, 'out')

          if(!check_out) {
            alert(
              "ไม่สามารถ Update Status ให้กับ Store ที่ยังไม่มีการ Check Out ได้"
            );
            return false;
          }

          this.updateByStore = true;      
        },

        onSetStatus(value) {
          // if (this.statusRight.isenabled == 0) {
          //   return;
          // }
          this.$set(this, "status_plan", value);
        },
        
        async confirmByStore(close = true) {
          if (close) {
            this.updateByStore = false;
          }

          this.$set(
            this,
            "export_progress",
            "กำลังบันทึกข้อมูล Visit กรุณารอจนกว่ากระบวนการจะเสร็จสิ้น"
          );
          this.$set(this, "loadingx", true);

          let data_checkin = $linq(this.dataList).where(w => w.type == 'Check In').firstOrDefault()
          let data_callcard = $linq(this.dataList).where(w => w.img_type == 'CC').toArray()

          var data = await xtools.postServerJson(
            "AccountingforLabor/Transaction/recheckByStoreLabour_ShareService",
            { dataCheckin: data_checkin, dataSubD: data_callcard, status: this.status_plan }
          );

          if (data.success == true) {
            await xtools.onSaveActionLogs(
              this.$route.meta.module,
              this.$route.meta.nameMenu + " [Update & Recheck By Store]",
              data.data
            );

            this.$notify(
              "success filled",
              "Message System",
              "Save data successfully.",
              { duration: 3000, permanent: false }
            );

          } else {
            alert(data.error)
            this.setStatusShow = false;
            this.$notify("error filled", "Message System", "Failed to save data.", {
              duration: 3000,
              permanent: false,
            });
          }

          this.$set(this, "loadingx", false);
          this.updateByStore = false;
          this.onloadData()         
        },        
        
      },
      mounted () {
        this.docno = this.$route.query.docno;
        this.datechk = this.$route.query.datechk;
        this.empcode = this.$route.query.empcode;
        this.is_locked = this.$route.query.locked;

        this.onLoadStore()
    
        this.linkGen()

        if (!xtools.isEmpty(this.subRight)) {
        this.statusRight = $linq(this.subRight)
          .where((x) => x.menu_id == "10710")
          .firstOrDefault() || { isenabled: 0 };        
      }
    
      }
    }
    </script>
    
    <style scoped>
    .card .card-body {
       padding-left:0.5rem;
       padding-right:0.5rem;
       padding-top:0.5rem;
       padding-bottom:0.5rem;
    }
    
    .tableMain {
        color: #333;
        width: 640px;
        border-collapse:
        collapse; border-spacing: 0;
        width: 100%;
    
    }
    
    .classError{
      color: #d50000;
    }
    
    .textTime{
      font-size: 18px;
      color: #2E7D32;
      font-weight: 600;
    }
    
    .imgClass{
      border-radius:10px;
      border: 2px solid #CFD8DC;
    }

    .texth{
      color: #000;
    }

    .classHover:hover {
    background-color: #607d8b !important;
    color: #fff;
  }
  
  .classStatusActive {
    background-color: #4caf50 !important;
    color: #fff !important;
  }

  .classStatusRed {
    background-color: #ef5350 !important;
    color: #fff !important;
  }

  .topClass {
    margin-top: 20px;
    padding: 5px;
  }

  .textClass {
    font-size: 14px;
    margin-top: 20px;
  }

  .statusText {
    font-weight: 500;
    color: #000;
    font-size: 16px;
  }
    </style>
    